import React, { useState, useEffect, useCallback } from 'react';
import { format, parseISO } from 'date-fns';
import { toast } from 'react-toastify';
import api from '~/services/api';
// Importando componentes
import Card from '~/components/Card';
import Table from '../Atendimento/Table';
import Load from '~/components/Load';

import { Container, Menus, Filtro, DS, Button } from './styles';

export default function Relatorio() {
  const [dados, setDados] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [dateInit, setDateInit] = useState(null);
  const [dateFinish, setDateFinish] = useState(null);
  const [dataInicial, setDataInicial] = useState(null);
  const [dataFinal, setDataFinal] = useState(null);
  const [reset, setReset] = useState(false);
  const [loading, setLoading] = useState(true);
  const [carregar, setCarregar] = useState(false);
  const [search, setSearch] = useState('');

  const getTarefas = useCallback(async () => {
    setCarregar(true);
    const responseTarefa = await api.get('/tarefas-relatorio', {
      params: {
        page,
        perPage,
        name: search,
        data_init: dataInicial,
        data_finish: dataFinal,
      },
    });
    const data = responseTarefa.data.data.map(tarefa => {
      return {
        ...tarefa,
        atrasadoFormat: tarefa.atrasado === '1' ? 'Sim' : 'Não',
        dataAtendimento: format(
          parseISO(tarefa.data_atendimento),
          'dd/MM/yyyy HH:mm:ss'
        ),
        dataCriacao: format(parseISO(tarefa.created_at), 'dd/MM/yyyy HH:mm:ss'),
      };
    });
    setPage(responseTarefa.data.page);
    setPerPage(responseTarefa.data.perPage);
    setTotal(Number(responseTarefa.data.total));
    setDados(data);
    setReset(false);
    setLoading(false);
    setCarregar(false);
  }, [dataFinal, dataInicial, page, perPage, search]);

  useEffect(() => {
    getTarefas();
  }, [getTarefas]);

  // Criando dados da coluna
  const columns = [
    {
      name: 'id',
      label: 'Id',
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: 'user.name',
      label: 'Nome',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'incorporadora.name',
      label: 'Incorporadora',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'time.name',
      label: 'Time',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'atendimento.lead.name',
      label: 'Lead atendido',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'atividade',
      label: 'Atividade',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'atrasadoFormat',
      label: 'Atendimento foi atrasado',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'dataAtendimento',
      label: 'Data de atendimento',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'dataCriacao',
      label: 'Data da tarefa',
      options: {
        filter: false,
        sort: false,
      },
    },
  ];

  function handleFiltrar() {
    if (dateInit && dateFinish) {
      const dtI = format(dateInit, 'yyyy-MM-dd');
      const dtF = format(dateFinish, 'yyyy-MM-dd');

      setDataInicial(dtI);
      setDataFinal(dtF);
    } else {
      toast.error('Preencha os campos data inicial e data final');
    }
  }

  async function handlePagination(number) {
    setPage(number);
  }

  async function handlePerPage(number) {
    setPerPage(number);
  }

  function handleSearch(value) {
    setSearch(value);
    setPage(1);
  }

  async function handleReset() {
    setSearch('');
    setDataInicial(null);
    setDataFinal(null);
    setDateInit(null);
    setDateFinish(null);
  }

  if (loading) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Relatório</h4>
      <Card>
        <Menus>
          {reset ? (
            <Button type="button" onClick={getTarefas} reset>
              Resetar
            </Button>
          ) : (
            <Filtro>
              <DS
                selected={dateInit}
                onChange={date => setDateInit(date)}
                locale="pt-BR"
                placeholderText="Data inicial"
                dateFormat="dd/MM/yyyy"
                showPopperArrow={false}
                withPortal
              />
              <DS
                selected={dateFinish}
                onChange={date => setDateFinish(date)}
                locale="pt-BR"
                minDate={dateInit}
                placeholderText="Data final"
                dateFormat="dd/MM/yyyy"
                showPopperArrow={false}
                withPortal
              />
              <Button type="button" onClick={handleFiltrar}>
                Filtrar
              </Button>
            </Filtro>
          )}
        </Menus>
        {!loading && (
          <Table
            data={dados}
            page={page}
            perPage={perPage}
            columns={columns}
            total={total}
            pagination={number => handlePagination(number)}
            editPerPege={number => handlePerPage(number)}
            search={value => handleSearch(value)}
            loading={carregar}
            handleExportCSV={() => {}}
            handleFilterSubmit={() => {}}
            reset={handleReset}
          />
        )}
      </Card>
    </Container>
  );
}
